import { atom } from 'recoil';

export const videoUrlsState = atom({
  key: 'videoUrlsState',
  default: [] as string[],
});
